const ro = {
    serviceCall: "Furnizorul de servicii poate suna",
    heading_request: 'Care sunt detaliile?',
    valid_question1: "Detalii pe care le vezi relevante?",
    valid_question2:         'Dacă nu furnizați suficiente informații, macar 100 de caractere, acest lucru va afecta numărul de oferte pe care le veți primi.',
    valid_question3:         "Trebuie să introduceți cel puțin 100 de litere.",
    image_question: 'Doriți să adăugați fotografii?',
    where_location: 'Unde este ? (La locul de muncă)',
    location_validation:         'Nu vă putem folosi locația. Vă rugăm să căutați orașul sau introduceți manual',
    userMyLocation: 'FOLOSESTE LOCATIA MEA',
    enterCity: 'Introduceți numele orașului dvs',
    when_job: 'Cand ? (data de lucru)',
    answer_question: 'Vrei să răspunzi la aceste întrebări?',
    inputAnswer: 'Introdu raspunsul tau aici...',
    enterPhone: 'Introduceți telefonul dvs',
    phoneDescription:         'Profesioniștii noștri vă vor contacta mai repede dacă selectați "Contacteaza-ma la telefon”.',
    enterPhoneNumber: 'Introdu numarul tau de telefon',
    sendRequest: 'TRIMITE CEREREA',
    alert_image: "Încărcați cel puțin o imagine.",
    alert_description: 'Introduceți o descriere.',
    alert_address: 'Introdu adresa ta.',
    alert_one_option: 'Selecteaza o optiune.',
    alert_pick_date: 'Vă rugăm să ridicați data.',
    alert_answer: "Vă rugăm să răspundeți la întrebare",
    alert_phone: 'Introdu numarul tau de telefon.',
    request_success_msg: 'Felicitari! Ați solicitat cu succes!',
    alert_close_description:         'Puteți obține oferte gratuite răspunzând la câteva întrebări suplimentare.',
    go_on: 'CONTINUA',
    quit: 'IEȘI',
    servicesCompanyReady: "Firma de servicii gata",
    allow_contacts: "Arată numărul de telefon",
    dont_disturbme: "Nu mă deranja",
    only_phone: "Contacteaza-ma doar la telefon",
    only_offers: "Contacteaza-ma doar la telefon",
    only_whatsapp: "Contacteaza-ma doar pe whatsapp",

    kEmailNullError: "Te rog introdu e-mailul tău",
    kInvalidEmailError: "Vă rugăm să introduceți un e-mail valid",
    kPassNullError: "Va rugam sa introduceti parola",
    kConfirmPasswordError: "Parola nepotrivită",
    kShortPassError:  "Parola este prea scurtă, cel puțin 8 caractere",
    kMatchPassError: "Parolele nu se potrivesc",
    kNameNullError: "Te rog sa introduci numele complet",
    kPhoneNumberNullError: "Vă rugăm să introduceți numărul dvs. de telefon",

    email: 'E-mail',
    password: 'Parola',
    pleaseendteryouremail: 'Te rog introdu e-mailul tău',
    pleaseenteryourpassword: 'Va rugam sa introduceti parola',
 
    
    confirmpassword: 'Confirmă parola',
    name: 'Nume',

    requestPriority: 'Cerere Prioritate',
    Congratulation: 'Felicitari',


    free: 'Liber',
    high: "înalt",

    noSearchResult: 'Niciun rezultat al căutării',
    inputThree: 'Vă rugăm să introduceți cel puțin 3 litere',

    selected_city: 'Orașele selectate',

    specificTime: 'Timp specific (în termen de trei săptămâni)',
    inTwoMonth: 'În două luni',
    inSixMonth: 'În șase luni',
    onlyPrice: 'Caut doar pretul',
    flexibleTime: 'Flexibil',
    asap: 'Cât mai repede posibil',

    lab_continue: 'Continua',


  //CUSTOM
  mainheading: 'Ce tip de servicii cauti?',
  back: 'Înapoi',
  serviceErrHead: 'Serviciu gol',
  serviceError: 'Vă rugăm să selectați un serviciu pe care îl căutați pentru a continua.',

  requiredField: "câmp necesar",
  requireDesc: 'Acest camp este obligatoriu.'

}

export default ro;